import { type SalesTeamSearch, isSalesTeamTab } from "./SalesTeamView";

/** `?tab=&month=` — giá trị lạ thì bỏ qua, không làm hỏng trang. */
export function parseSalesTeamSearch(search: Record<string, unknown>): SalesTeamSearch {
  const out: SalesTeamSearch = {};
  if (isSalesTeamTab(search.tab)) out.tab = search.tab;
  if (typeof search.month === "string" && /^\d{4}-\d{2}$/.test(search.month)) out.month = search.month;
  return out;
}
